import { api } from './client.js';

export interface Project {
  projectId: string;
  name: string;
  color: string;
  order: number;
  hideFromAgenda: boolean;
  createdAt: string;
}

export async function listProjects(init: RequestInit = {}): Promise<Project[]> {
  const r = await api<{ projects: Project[] }>('/projects', init);
  return r.projects;
}

export async function createProject(input: {
  name: string;
  color: string;
  order?: number;
}): Promise<Project> {
  const r = await api<{ project: Project }>('/projects', {
    method: 'POST',
    body: JSON.stringify(input),
  });
  return r.project;
}

export async function updateProject(
  pid: string,
  patch: Partial<Omit<Project, 'projectId' | 'createdAt'>>
): Promise<Project> {
  const r = await api<{ project: Project }>(`/projects/${pid}`, {
    method: 'PATCH',
    body: JSON.stringify(patch),
  });
  return r.project;
}

export async function deleteProject(pid: string): Promise<void> {
  await api<void>(`/projects/${pid}`, { method: 'DELETE' });
}
